import { formatFileSize } from '@/scripts/utils/file-analyzer';
import { FileTypeIcon } from '@/configs/options/file';
import styles from './index.module.scss';
// import EditIcon from './images/edit.svg?react';
import DeleteIcon from './images/delete.svg?react';

interface FileItemProps {
  file: File;
  handleDelete: (file: File) => void;
}

export default function FileItem({ file, handleDelete }: FileItemProps) {
  return (
    <div className={styles.fileItem}>
      <div className={styles.file}>
        <FileTypeIcon extType={file.name.split('.').pop()!} file={file} />
        <div className={styles.fileInfo}>
          <div className={styles.fileName}>{file.name}</div>
          <div className={styles.fileSize}>{formatFileSize(file.size)}</div>
        </div>
      </div>
      <div className={styles.actions}>
        {/* <EditIcon className="pointer" /> */}
        <DeleteIcon className="pointer" onClick={() => handleDelete(file)} />
      </div>
    </div>
  );
}
